import stoneService from '@services/magento/stone.service';

import { StoneInventory } from '@stone/interfaces';

export async function fetchInventoryApi(params: any = {}): Promise<{ items: StoneInventory[]; totalCount: number }> {
  const response = await stoneService.getStoneInventories(params);
  return {
    items: response.items || [],
    totalCount: response.total_count || 0,
  };
}

export async function saveStoneApi(data: any): Promise<any> {
  return await stoneService.saveStoneInventory(data);
}
